import React, { useState } from "react";
import { FaLock, FaUserMd, FaMinus, FaPlus, FaFileMedical, FaShieldAlt, FaCode, FaMobileAlt, FaHospitalUser, FaChartLine, FaNotesMedical, FaCogs, FaLaptopMedical, FaCloud, FaSync, FaClipboardList, FaServer } from "react-icons/fa";

import Medpalm from "../../../assests/Healthcaretechnology/Electronic HealthRecords.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Electronic Health Records (EHR) Implementation",
        "description":
            "Deploy a robust and scalable digital patient record system to centralize medical history, treatment plans, prescriptions, and diagnostic results. EHR implementation enhances clinical workflows, improves data accessibility, and ensures seamless interoperability between healthcare providers. By digitizing patient records, organizations can enhance care coordination, optimize decision-making, and maintain regulatory compliance with HIPAA and other industry standards."
    },
    {
        "title": "Data Integration with Telehealth",
        "description":
            "Enable real-time connectivity between telemedicine platforms and EHR systems to support virtual consultations, remote patient monitoring, and efficient data sharing. This integration enhances patient engagement, reduces administrative overhead, and ensures providers have instant access to accurate medical records. Seamless interoperability between EHR and telehealth solutions leads to better care continuity, improved patient outcomes, and streamlined reimbursement processes."
    },
    {
        "title": "Health Information Exchange (HIE)",
        "description":
            "Facilitate secure and efficient sharing of patient health data across hospitals, clinics, pharmacies, and healthcare networks. HIE ensures that healthcare providers have timely access to accurate patient information, reducing redundant tests, minimizing errors, and improving care coordination. Implementing HIE solutions enhances interoperability, strengthens population health management, and supports value-based care initiatives."
    },
    {
        "title": "EHR Compliance & Security Audits",
        "description":
            "Integrate AI-powered decision support tools within EHR systems to assist healthcare professionals in diagnosis, treatment planning, and medication management. CDSS solutions provide real-time alerts, evidence-based recommendations, and predictive analytics, helping clinicians make data-driven decisions. By enhancing patient safety and reducing medical errors, CDSS improves clinical efficiency and supports personalized patient care."
    },
    {
        "title": "Healthcare Analytics",
        "description":
            "Implement analytics solutions that utilize patient data from your EHR systems to gain actionable insights, improve care, and optimize healthcare operations."
    },
    // {
    //     "title": "EHR Data Analytics & Reporting",
    //     "description":
    //         "Harness AI-driven analytics to extract meaningful insights from patient data, monitor clinical performance, and optimize hospital operations. Advanced reporting tools help healthcare organizations identify trends, track population health metrics, and make data-driven decisions. By leveraging predictive analytics and compliance-driven reporting, providers can enhance quality of care, improve resource allocation, and support regulatory adherence."
    // }
]

const features = [
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Digital storage and retrieval of patient health records." },
    { icon: <FaCloud className="text-[#2a627a] text-lg" />, text: "Cloud-based EHR solutions for secure and scalable access." },
    { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "HIPAA-compliant encryption for data security and patient privacy." },
    { icon: <FaSync className="text-[#2a627a] text-lg" />, text: "Interoperability for seamless exchange of patient health data." },
    // { icon: <FaMobileAlt className="text-[#2a627a] text-lg" />, text: "Mobile access to EHR systems for on-the-go healthcare providers." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Real-time data analytics for predictive healthcare insights." }
];

const benefits = [
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Improves efficiency by reducing paperwork for healthcare providers." },
    { icon: <FaHospitalUser className="text-[#2a627a] text-lg" />, text: "Enhances patient engagement with digital health tools." },
    { icon: <FaClipboardList className="text-[#2a627a] text-lg" />, text: "Automating administrative tasks and reducing paperwork improves operational efficiency, allowing healthcare professionals to focus more on patient care." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Our EHR solutions ensure full compliance with healthcare regulations such as HIPAA and GDPR, safeguarding patient data and preventing penalties." },
    { icon: <FaServer className="text-[#2a627a] text-lg" />, text: "EHR systems facilitate collaboration between healthcare providers, allowing for better care coordination and reducing the risk of errors." },
    // { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Ensures compliance with healthcare regulations and security standards." }
];
const cmsFeatures = [
    { icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />, text: "EHR Implementation Specialist – Manages system deployment and training." },
    { icon: <FaCode className="text-[#2a627a] text-lg" />, text: "Health IT Developer – Designs and maintains EHR software solutions." },
    { icon: <FaSync className="text-[#2a627a] text-lg" />, text: "EHR Integration Engineer – Ensures seamless data exchange between systems." },
    { icon: <FaCogs className="text-[#2a627a] text-lg" />, text: "Healthcare IT Support Specialist – Provides technical assistance for EHR users." },
    // { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Healthcare Data Analyst – Extracts insights from patient records for better decision-making." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Cybersecurity Officer – Protects patient health data from breaches and cyber threats." }
];
const ElectronicHealthRecords = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 ">Electronic Health Records (EHR) - <span className="text-gray-800">Health IT</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Enhancing healthcare efficiency with secure, interoperable EHR systems and advanced Health IT solutions for seamless data exchange and patient care."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is EHR & Health IT?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Electronic Health Records (EHR) are digital versions of patient medical history, including diagnoses, medications, treatment plans, allergies, lab results, and imaging reports. They replace traditional paper records and improve data accuracy, accessibility, and security.

                            Health IT (Health Information Technology) refers to the use of digital tools like EHR systems, AI-driven analytics, and cloud-based health solutions to enhance patient care, optimize workflows, and improve healthcare decision-making.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Electronic Health Records & Health IT
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

<span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default ElectronicHealthRecords;
